module.exports = __webpack_public_path__ + "media/bacmusic.da765ec0.mp3";